const replaceNewLinesToSpaces = (value: string) =>
  value.replace(/(\r\n|\n|\r)/gm, ' ');

export default replaceNewLinesToSpaces;
